import {
  StorageOfUniqueServices,
  AxiosWrapperService as axios,
} from '@qality/common-service';

export default {
  async getQAlityRelationId(): Promise<number> {
    const url = await StorageOfUniqueServices.get(
      'AuthenticateService'
    ).authenticateByJWT(
      StorageOfUniqueServices.get('WindowOriginService').origin +
        StorageOfUniqueServices.get('APIConstants').URL_QALITY_ISSUE_LINK_TYPE
    );
    const response = await axios.get(url);
    return response.data;
  },
};
